import { ArrowRight } from '@dreamstack/icons'
import type { FunctionComponent } from 'react'
import 'twin.macro'
import tw, { styled } from 'twin.macro'
import { HeadingH3 } from './layout/Texts'

const TileWrapper = styled.div<{
  small?: boolean
  backgroundImageUrl?: string
}>(({ small, backgroundImageUrl }) => [
  small
    ? tw`text-accentroGray-full `
    : tw`bg-accentroGray-full text-accentroWhite-full p-px-16 h-px-196 md:(p-px-24) lg:(h-px-274 px-px-48 pb-px-32)`,
  backgroundImageUrl
    ? `background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.8)), url(${backgroundImageUrl});`
    : ``,
  tw`flex flex-col justify-end cursor-pointer relative bg-cover`,
])

const SubBox = styled.div<{ small?: boolean }>(({ small }) => [
  small ? tw`mt-px-4` : tw`mt-px-12`,
  tw`flex items-center`,
])

const ActionTileCaption = styled.p<{ small?: boolean }>(({ small }) => [
  small
    ? tw`text-px-16 leading-px-24 md:(text-px-20 leading-px-30) ml-px-16 font-normal`
    : tw`text-px-16 leading-px-24 ml-px-12 font-semibold`,
  tw`flex items-center space-x-px-12`,
])

const StyledH3 = tw(HeadingH3)``

export const StyledTileHeader = tw.h4`text-px-20 leading-px-30 font-semibold inline`

const Divider = styled.p<{ small?: boolean }>(({ small }) => [
  small ? tw`bg-accentroGray-full` : tw`bg-accentroWhite-full`,
  tw`h-px-4 w-px-4 rounded-full`,
])

const HeadingWrapper = styled.div<{ small?: boolean }>(({ small }) => [
  tw`font-semibold overflow-clip break-words flex justify-between items-center`,
  small
    ? tw`text-px-20 leading-px-30 md:(text-px-28 leading-px-42) lg:(text-px-32 leading-px-44)`
    : tw`text-px-20 leading-px-30 md:(text-px-24 leading-px-36) lg:(text-px-48 leading-px-60)`,
])

export const FileDownloadInline: FunctionComponent<React.PropsWithChildren<FileDownloadInlineProps>> = ({
  icon,
  caption,
  fileSize,
  small,
}) => {
  return (
    <SubBox small={small}>
      {icon}
      <ActionTileCaption small={small}>
        <span tw="uppercase">{caption}</span>
        {fileSize && (
          <>
            <Divider small={small} />
            <span>{fileSize}</span>
          </>
        )}
      </ActionTileCaption>
    </SubBox>
  )
}

interface FileDownloadInlineProps {
  icon?: JSX.Element
  caption: string
  fileSize?: string
  small?: boolean
}

interface ActionTileProps {
  heading: string
  small?: boolean
  backgroundImgUrl?: string
  onlyLink?: boolean
}

export const ActionTile: FunctionComponent<React.PropsWithChildren<ActionTileProps & FileDownloadInlineProps>> = ({ heading, small, backgroundImgUrl, onlyLink, ...rest }) => {
  return (
    <TileWrapper backgroundImageUrl={backgroundImgUrl} small={small}>
      <div tw="">
        <HeadingWrapper>
          {small ? (
            <StyledH3
              dangerouslySetInnerHTML={{ __html: heading }}
              title={heading}
            />
          ) : (
            <StyledTileHeader
              dangerouslySetInnerHTML={{ __html: heading }}
              title={heading}
            />
          )}
          {onlyLink && <ArrowRight tw="flex-shrink-0 h-px-32 w-px-32" />}
        </HeadingWrapper>
        {!onlyLink && <FileDownloadInline {...rest} small={small} />}
      </div>
    </TileWrapper>
  )
}
